import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {CommonModule} from "@angular/common";
import {OnlineStatusIndicatorComponent} from "../online-status-indicator/online-status-indicator.component";
import {IReceiver} from "../../../../models/i-receiver";

@Component({
  selector: "app-receiver-list-item",
  standalone: true,
  imports: [CommonModule, OnlineStatusIndicatorComponent],
  templateUrl: "./receiver-list-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReceiverListItemComponent {
  @Input({required: true}) receiver!: IReceiver;
  @Input() isActive: boolean = false;
  @Output() onSelect = new EventEmitter<IReceiver>();

  public selectReceiver(): void {
    this.onSelect.emit(this.receiver);
  }
}
